import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import { useEffect } from 'react';

var useFocusTrap = function useFocusTrap(elementRef) {
  var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  useEffect(function () {
    var trapElement = elementRef.current;
    if (enabled && trapElement) {
      var handleKeyDown = function handleKeyDown(event) {
        var focusableElements = trapElement.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), audio[controls], video[controls], [contenteditable]');
        var filteredFocusableElements = _toConsumableArray(focusableElements).filter(function (el) {
          var computedStyle = window.getComputedStyle(el);
          return !(el.offsetWidth === 0 && el.offsetHeight === 0) && el.tabIndex !== -1 && computedStyle.visibility !== 'hidden' && computedStyle.display !== 'none';
        });
        var firstFocusable = filteredFocusableElements[0];
        var lastFocusable = filteredFocusableElements[filteredFocusableElements.length - 1];
        var notInFocusableElements = !filteredFocusableElements.includes(document.activeElement);
        if (event.key === 'Tab') {
          if (document.activeElement === lastFocusable && !event.shiftKey || notInFocusableElements) {
            event.preventDefault();
            firstFocusable.focus();
          } else if (document.activeElement === firstFocusable && event.shiftKey) {
            event.preventDefault();
            lastFocusable.focus();
          }
        }
      };
      document.addEventListener('keydown', handleKeyDown);
      return function () {
        document.removeEventListener('keydown', handleKeyDown);
      };
    }
    return undefined;
  }, [elementRef, enabled]);
};
var useFocusTrap$1 = useFocusTrap;

export { useFocusTrap$1 as default };
//# sourceMappingURL=useFocusTrap.js.map
